module.exports = __webpack_public_path__ + "static/media/all-stories-dark.7daa4e7d.png";